import { gql } from '@apollo/client';
import { UserMode } from '../../hooks/useApolloClient';
import {
  COMPANY_CREDENTIALS,
  MY_PROFILE,
} from '../../modes/company/pages/profile/CompanyProfile.query';

const GET_INBOUND_ASSIGNMENT = (mode: UserMode) => gql`
  query GetInboundAssignment($where: JSON) {
    inboundAssignments(where: $where) {
      id
      status
      jobId
      #     flags
      job {
        id
        address {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        formData
        attachments {
          id
          contentType
          url
          thumb(size: 500)
          profile {
            id
            name
          }
          created
        }
        siteContact {
          id
          name
          address {
            id
            street1
            street2
            city
            state
            zip
            zipExt
          }
          email
          phone
          notes
        }
        comments {
          id
          type
          comment
          profile {
            id
            name
          }
          created
        }
        statusChanges {
          id
          fromStatus
          toStatus
          profile {
            id
            name
          }
          created
        }
        backflowTest {
          jobId
          testerName
          waterSupplier {
            profileId
            rpCheck2Type
          }
          dateTested
          finalResult
          originalBackflowAssembly {
            id
            modelId
            model {
              id
              name
              backflowAssemblyMake {
                name
              }
            }
            serialNumber
            size
            type
            location
          }
          backflowAssembly {
            id
            modelId
            model {
              id
              name
              backflowAssemblyMake {
                id
                name
              }
            }
            serialNumber
            size
            type
            location
            installDate
            ${
              mode === 'company'
                ? `waterService {
              id
              meterNumber
              pin
            }`
                : ''
            }
          }
        }
      }
      vendorSubmissionFee
      customer {
        id
        profile {
          id
          name
          contactAddress {
            id
            street1
            street2
            city
            state
            zip
          }
          emails {
            subType
            value
          }
          phones {
            subType
            value
            extension
          }
        }
        notes
      }
      ${
        mode === 'company'
          ? `
      child {
        id
        vendorProfile {
          id
          name
          type
        }
      }`
          : ''
      }
    }
  }
`;

export const GET_FEE_AND_DEFAULT_PAYMENT_METHOD = gql`
  query GetFeeAndDefaultPaymentMethod($assignmentId: ID!) {
    stripePlatformCustomer {
      defaultPaymentMethodId
    }
    inboundAssignments(where: { id: $assignmentId }) {
      id
      vendorSubmissionFee
    }
  }
`;

export const GET_INBOUND_ASSIGNMENT_COMPANY = GET_INBOUND_ASSIGNMENT('company');
export const GET_INBOUND_ASSIGNMENT_INDIVIDUAL =
  GET_INBOUND_ASSIGNMENT('individual');

export const ASSIGN_JOB = gql`
  mutation AssignJob(
    $assignmentId: ID!
    $vendorProfileId: ID!
    $dueDate: String
  ) {
    assignInboundAssignments(
      assignmentIds: [$assignmentId]
      vendorProfileId: $vendorProfileId
      dueDate: $dueDate
    ) {
      id
      status
      child {
        id
        status
        vendorProfile {
          id
          name
        }
        due
      }
    }
  }
`;

export const SET_JOB_FORM_VALUES = gql`
  mutation SetJobFormValues($jobId: ID!, $values: JSON!) {
    setJobFormValues(jobId: $jobId, values: $values) {
      id
    }
  }
`;

export const SET_ASSIGNMENT_STATUS = gql`
  mutation SetInboundAssignmentStatus(
    $assignmentId: ID!
    $newStatus: AssignmentStatus!
    $oldStatus: AssignmentStatus!
  ) {
    setInboundAssignmentStatus(
      assignmentId: $assignmentId
      newStatus: $newStatus
      oldStatus: $oldStatus
    ) {
      id
      status
      jobId
      completed
      submitted
      job {
        id
      }
    }
  }
`;
